import React from 'react'
import {
  Icon,
  Table,
  Input,
  Dimmer,
  Loader,
  Button,
  Header,
} from 'semantic-ui-react'
import size from 'lodash/size'
import orderBy from 'lodash/orderBy'
import upperCase from 'lodash/upperCase'

import DriverRow from './driverRow'
import DriverForm from '../forms/driverForm'
import DeliveryFeeForm from '../forms/feeRateForm'

const initData = {
  first_name: '',
  family_name: '',
  package_size: 'medium',
  tel: '',
  status: 'available',
  delivery_fee_rate: 0,
  region: 'pnh',
  max_payable_amount: 20,
  aba: { number: '', name: '' },
  radius: 0,
  identity_number: '',
}

class DriverList extends React.Component {
  state = {
    action: null,
    modalVisible: false,
    modalFeeRateVisible: false,
    driverData: null,
    baseOnRegion: true,
    driverCount: { all: 0 },
    searchText: '',
  }

  componentDidMount() {
    this.countDriverByRegion()
  }

  componentDidUpdate(prevProps) {
    const { drivers } = this.props

    if (drivers.length !== prevProps.drivers.length) {
      this.countDriverByRegion()
    }
  }

  onRemove = driver => {
    const { deleteDriver } = this.props

    const confirm = window.confirm(`Are you sure to remove ${driver.family_name} ${driver.first_name}?`)

    if (confirm) {
      deleteDriver(driver.driverUID)
    }
  }

  onAdd = () => {
    this.setState({ driverData: initData, action: 'new', modalVisible: true })
  }

  onFeeRateClick = () => {
    this.setState({ modalFeeRateVisible: true })
  }

  onView = driverUID => {
    const { history } = this.props

    history.push({
      pathname: `/drivers/detail/${driverUID}`,
    })
  }

  onEdit = driver => {
    const dataToEdit = {
      first_name: driver.first_name || initData.first_name,
      family_name: driver.family_name || initData.family_name,
      package_size: driver.package_size || initData.package_size,
      tel: driver.tel || initData.tel,
      status: driver.status || initData.status,
      online: driver.online || initData.online,
      delivery_fee_rate: driver.delivery_fee_rate || initData.delivery_fee_rate,
      identity_number: driver.identity_number || initData.identity_number,
      radius: driver.radius || driver.radius,
      aba: driver.aba || initData.aba,
      max_payable_amount: driver.max_payable_amount || initData.max_payable_amount,
      region: driver.region || initData.region,
    }

    this.setState({ driverData: dataToEdit, action: 'edit', modalVisible: true })
  }

  onClose = () => {
    this.setState({ driverData: null, action: null, modalVisible: false })
  }

  onSaveDriver = () => {
    let { driverData } = this.state
    const { saveDriver } = this.props

    driverData = {
      ...driverData,
      tel: driverData.tel.replace(/\s/g, '').trim(),
    }

    saveDriver(driverData.tel, driverData, () => {
      this.onClose()
    })
  }

  onFieldChange = (field, value) => {
    let { driverData } = this.state

    driverData = {
      ...driverData,
      [field]: value,
    }

    this.setState({ driverData })
  }

  countDriverByRegion = () => {
    const { drivers } = this.props
    const driverCount = { all: 0 }

    drivers.forEach(driver => {
      const region = driver.region || 'pnh'

      driverCount[region] = driverCount[region] || 0
      driverCount[region] += 1
      driverCount.all += 1
    });

    this.setState({ driverCount })
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  onGoOnlineOffline = driver => {
    const { toggleDriverOnline } = this.props
    const driverName = `${driver.family_name} ${driver.first_name}`
    const onlineLabel = driver.online ? 'offline' : 'online'
    const confirm = window.confirm(`Are you sure to ${onlineLabel} ${driverName} ?`)
    if (confirm) {
      toggleDriverOnline(driver)
    }
  }

  renderDrivers = () => {
    const { drivers, driverSegments, user } = this.props
    const { baseOnRegion, searchText } = this.state

    const displayDrivers = drivers.filter(driver => !baseOnRegion || (driver.region || 'pnh') === user.region)
    const filterDrivers = displayDrivers.filter(driver => {
      const driverName = `${driver.family_name} ${driver.first_name}`.toLowerCase()

      if ((driver.tel && driver.tel.includes(searchText.toLowerCase())) ||
        driverName.includes(searchText.toLowerCase())
      ) {
        return driver
      }

      return null
    })

    const allDriver = searchText.length > 2 ? filterDrivers : displayDrivers
    const sortedDrivers = orderBy(allDriver, driver => driver.last_session, 'desc');

    return sortedDrivers.map((driver, index) => (
      <DriverRow
        driver={driver}
        index={index}
        driverSegment={driverSegments[driver.driver_segment]}
        key={driver.driverUID}
        onRemove={() => this.onRemove(driver)}
        onAdd={() => this.onAdd()}
        onEdit={() => this.onEdit(driver)}
        onView={() => this.onView(driver.driverUID)}
        onGoOnlineOffline={() => this.onGoOnlineOffline(driver)}
      />
    ))
  }

  renderNoDrivers = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={9} textAlign="center" style={{ padding: 40 }}>
          <Header size="small">No data available</Header>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderList = () => {
    const { drivers, driverAdding, user } = this.props
    const { modalVisible, modalFeeRateVisible, action, driverData, baseOnRegion, driverCount } = this.state

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0px 14px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <Button.Group>
              <Button
                basic={!baseOnRegion}
                color="black"
                onClick={() => this.setState({ baseOnRegion: true })}
                content={`${upperCase(user.region)} (${driverCount[user.region] || 0})`}
              />
              <Button
                basic={baseOnRegion}
                color="black"
                onClick={() => this.setState({ baseOnRegion: false })}
                content={`All Drivers (${driverCount.all})`}
              />
            </Button.Group>
          </div>
          <div style={{ display: 'flex' }}>
            <Input
              size="small"
              placeholder="Search..."
              style={{ marginBottom: 10, marginRight: 10 }}
              onChange={e => this.setState({ searchText: e.target.value })}
            />

            <div>
              <Button color="black" onClick={this.onFeeRateClick}>
                Delivery Fee Rate
              </Button>
              <Button icon color="black" onClick={this.onAdd}>
                <Icon name="add" /> Add Driver
              </Button>
            </div>
          </div>
        </div>
        <div style={{ padding: 14, textAlign: 'center' }}>
          <Table columns={9}>
            <Table.Header>
              <Table.Row style={{ fontWeight: 'bold' }}>
                <Table.Cell>Name</Table.Cell>
                <Table.Cell textAlign="center">Phone/Package</Table.Cell>
                <Table.Cell textAlign="center">Platform/Battery</Table.Cell>
                <Table.Cell textAlign="center">Credit/Cash</Table.Cell>
                <Table.Cell textAlign="center">Status</Table.Cell>
                <Table.Cell textAlign="center">Driver Segment</Table.Cell>
                <Table.Cell textAlign="center">Joined At</Table.Cell>
                <Table.Cell textAlign="center">Last Session</Table.Cell>
                <Table.Cell textAlign="center">Actions</Table.Cell>
              </Table.Row>
            </Table.Header>
          </Table>
        </div>
        <div
          style={{ overflow: 'auto', padding: '0px 14px' }}
          className="list-content"
        >
          <Table columns={9}>
            <Table.Body>{size(drivers) > 0 ? this.renderDrivers() : this.renderNoDrivers()}</Table.Body>
          </Table>
        </div>
        {driverData && (
          <DriverForm
            loading={driverAdding}
            visible={modalVisible}
            driverData={driverData}
            onClose={this.onClose}
            action={action}
            onFieldChange={this.onFieldChange}
            saveDriver={this.onSaveDriver}
          />
        )}
        <DeliveryFeeForm
          visible={modalFeeRateVisible}
          onClose={() => this.setState({ modalFeeRateVisible: false })}
        />
      </div>
    )
  }

  render() {
    const { loading, drivers } = this.props

    if (loading || !drivers) {
      return this.renderLoading()
    }

    if (drivers) {
      return this.renderList()
    }

    return null
  }
}

export default DriverList



// WEBPACK FOOTER //
// ./src/components/drivers/views/driversList.js